import { environment } from '../../environments/environment';

/** Base URL for Socket.IO (no `/api` suffix). Prefers `environment.ws`. */
export function getWebsocketBaseUrl(): string {
  const wsUrl = environment.ws?.trim();
  if (wsUrl) {
    return wsUrl.replace(/\/$/, '');
  }

  const baseUrl = environment.administrativoBaseUrl || 'http://localhost:3000';
  return baseUrl.replace(/\/api\/?$/, '');
}
